import { render, staticRenderFns } from "./EditorImage.vue?vue&type=template&id=896ac854&scoped=true&"
import script from "./EditorImage.vue?vue&type=script&lang=ts&"
export * from "./EditorImage.vue?vue&type=script&lang=ts&"
import style0 from "./EditorImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditorImage.vue?vue&type=style&index=1&id=896ac854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ac854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VDialog,VFileInput})
